import { Box, Button, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import queryString from 'query-string';
import { PAGE_SIZE } from 'services/constants/env';
import { COLORS } from 'services/constants/colors';
import { EasTableWithoutFilter } from 'ui/EasTableWithoutFilter';
import { HelpButton } from 'ui/HelpButton';
import { EHelpButtonArticles } from 'ui/HelpButton/constants';
import { getShopifyAppsRequest } from 'redux/reducers/shopifyApps/reducer';
import { getShopifyApps, getShopifyAppsLoader } from 'redux/reducers/shopifyApps/selectors';
import { TShopifyApp } from 'redux/reducers/shopifyApps/types';
import { PATHS } from 'routes/constants';
import { tableStructure } from './tableStructure';
import { AddDevAppDialog } from './AddDevAppDialog';

const ROWS = Array.from(new Array(5));

export const ShopifyDevApps: FC = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { search } = useLocation();
	const { page } = queryString.parse(search);

	const shopifyApps = useSelector(getShopifyApps);
	const shopifyAppsIsLoading = useSelector(getShopifyAppsLoader);

	const [addDialogOpen, setAddDialogOpen] = useState(false);

	const dispatchGetShopifyApps = () => {
		dispatch(
			getShopifyAppsRequest({
				pageNumber: page ? +page : 1,
				pageSize: PAGE_SIZE,
				filters: [],
				orderBy: [],
				searchString: '',
			}),
		);
	};

	useEffect(() => {
		dispatchGetShopifyApps();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page]);

	const handleLink = (appId: number) => {
		navigate(PATHS.SHOPIFY_DEV_APP_PAGE.replace(':appId', String(appId)));
	};

	return (
		<>
			<EasTableWithoutFilter<TShopifyApp>
				tableStructure={tableStructure}
				items={shopifyApps}
				itemsIsLoading={shopifyAppsIsLoading}
				handleAction={() => {}}
				handleLink={handleLink}
				skeletonRows={ROWS}
				highlightedRow={null}
			>
				<Box
					sx={{
						p: '2px 4px',
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<Typography sx={{ fontSize: '1.2rem', color: COLORS.PRIMARY, fontWeight: 'bold' }}>
						Shopify Dev App
					</Typography>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
						<Button
							variant="contained"
							size="small"
							startIcon={<Add />}
							onClick={() => setAddDialogOpen(true)}
						>
							Add New Dev App
						</Button>
						<HelpButton
							type={EHelpButtonArticles.SHOPIFY_DEV_APP_CONFIGURE}
							sx={{ fontSize: '1.5rem' }}
						/>
					</Box>
				</Box>
			</EasTableWithoutFilter>
			<AddDevAppDialog
				open={addDialogOpen}
				onClose={() => setAddDialogOpen(false)}
				onSuccess={dispatchGetShopifyApps}
			/>
		</>
	);
};
